import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const SolutionAdvantageStyle = styled('div')`
  ${media.mobile} {
    margin-left: 20px;
    width: calc(100% - 40px);
  }
  .solutionadvantage {
    &--body {
      margin-top: 17px;
    }
    &--item {
      display: flex;
      justify-content: space-between;
      &:not(:last-of-type) {
        border-bottom: 1px solid #e0e0e0;
        padding-bottom: 36px;
        margin-bottom: 12px;
        ${media.desktop} {
          padding-bottom: 43px;
          margin-bottom: 20px;
        }
      }
      &-title {
        font-family: 'Pretendard-Bold';
        font-size: 16px;
        color: #333333;
        line-height: 20px;
        max-width: 131px;
        flex: none;
        word-break: keep-all;
        ${media.desktop} {
          font-size: 18px;
          line-height: 22px;
          max-width: 150px;
        }
      }
      &-desc {
        flex: none;
        ${media.mobile} {
          font-size: 13px;
          line-height: 20px;
          color: #555555;
          max-width: calc(100% - 168px);
        }
        ${media.desktop} {
          font-size: 16px;
          line-height: 24px;
          color: #757575;
          width: 672px;
        }
      }
    }
  }
`;

export default SolutionAdvantageStyle;
